module.exports = __webpack_public_path__ + "img/typing.066605db.png";